/**
 * Dernière personne choisie pour un champ « Personne » à `person_default: last` (ADR-152 §3), sur ce navigateur :
 * une proposition au départ, jamais une réponse (le serveur valide la valeur comme une saisie). Module isolé : il
 * n'écrit qu'un identifiant de personne (hexadécimal, 24 caractères) sous son préfixe, par gabarit et par champ,
 * et ne nomme rien d'autre. Un stockage fermé (navigation privée) ne propose simplement rien.
 */

export const LAST_PERSON_PREFIX = 'ayumia.form-person.last:';

const OBJECT_ID = /^[0-9a-f]{24}$/;

export function readLastPerson(templateKey: string, fieldId: string): string | undefined {
  try {
    const value = window.localStorage.getItem(`${LAST_PERSON_PREFIX}${templateKey}:${fieldId}`);
    return value !== null && OBJECT_ID.test(value) ? value : undefined;
  } catch {
    return undefined;
  }
}

export function writeLastPerson(templateKey: string, fieldId: string, id: string): void {
  if (!OBJECT_ID.test(id)) return;
  try {
    window.localStorage.setItem(`${LAST_PERSON_PREFIX}${templateKey}:${fieldId}`, id);
  } catch {
    // Stockage fermé : la valeur au départ ne sera pas proposée.
  }
}
